/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Weight_NetInputs */

const en_attribute_weight_net = /** @type {(inputs: Attribute_Weight_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net weight`)
};

/**
* | output |
* | --- |
* | "Net weight" |
*
* @param {Attribute_Weight_NetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_weight_net = /** @type {((inputs?: Attribute_Weight_NetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Weight_NetInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_weight_net(inputs)
});